var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConversation1 = function SvgConversation1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#232322",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12.35 30.667a5.84 5.84 0 0 0-11.017 0m29.335-16.623a5.84 5.84 0 0 0-11.016 0m-.067 8.8H24.8M11.111 5.896H5.896m11.082 21.837h1.955v2.934l3.912-2.934h5.866a1.956 1.956 0 0 0 1.956-1.955V19.91a1.956 1.956 0 0 0-1.956-1.956H16.978a1.956 1.956 0 0 0-1.956 1.956v5.867a1.956 1.956 0 0 0 1.956 1.955M3.418 22.35a3.416 3.416 0 1 0 6.833 0 3.416 3.416 0 0 0-6.832 0M21.75 5.739a3.417 3.417 0 1 0 6.833 0 3.417 3.417 0 0 0-6.833 0m-6.728 5.372h-1.955v2.933l-3.911-2.933H3.289a1.956 1.956 0 0 1-1.956-1.956V3.29A1.956 1.956 0 0 1 3.29 1.333h11.733a1.956 1.956 0 0 1 1.956 1.956v5.866a1.956 1.956 0 0 1-1.956 1.956",
    vectorEffect: "non-scaling-stroke"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
export default SvgConversation1;